import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { AlertTriangle, X } from 'lucide-react';

const LicenseDeleteModal = ({ license, onConfirm, onClose, submitting }) => {
  const { t } = useTranslation();

  if (!license) return null;

  const userName = license.user ? `${license.user.firstName} ${license.user.lastName}` : '';

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 modal-backdrop"
      onClick={submitting ? undefined : onClose}
    >
      <div
        className="modal-content bg-white rounded-xl shadow-xl max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-6 h-6 text-red-500" />
            <h2 className="text-xl font-bold text-gray-900">{t('licences.deleteModal.title')}</h2>
          </div>
          <button onClick={onClose} disabled={submitting} className="text-gray-400 hover:text-gray-600 disabled:opacity-50">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <p className="text-sm text-gray-600">
            <Trans
              i18nKey="licences.deleteModal.message"
              values={{ displayId: license.displayId, userName }}
              components={{ 1: <strong /> }}
            />
          </p>
        </div>

        <div className="flex justify-end gap-2 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            disabled={submitting}
            className="btn-secondary px-4 py-2 disabled:opacity-50"
          >
            {t('licences.deleteModal.cancel')}
          </button>
          <button
            onClick={onConfirm}
            disabled={submitting}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium disabled:opacity-50"
          >
            {t('licences.deleteModal.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LicenseDeleteModal;
